import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, SimpleChange } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, lastValueFrom, takeUntil } from 'rxjs';
import { IItemToRequest, MyPurchaseForm, VendorTagging } from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { Vendor } from 'src/app/shared/models/database-models';
import SourcingStatus from 'src/app/data/constants/SourcingStatus.json';
import { addVendorTagging } from 'src/app/core/store/TaggedVendors.action';
import { isEqual } from 'lodash';
import { UserInformation } from 'src/app/shared/models/app-models/UserInformation.model';
import _ from 'lodash';
import { StoreDropdowns } from 'src/app/shared/models/app-models';
import { doesNotMeetRfsCriteria } from '../../shared/utils/check-rfs-criteria';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';

export interface VendorTaggingTable {
  SourcingStatusName: string | null;
  itemId: number;
  displayItemNumber: number;
  ItemDescription: string;
  VendorsTagged: string;
  MaterialSubGroupName: string;
  isEditable: boolean;
}
@Component({
  selector: 'app-tagging',
  templateUrl: './tagging.component.html',
  styleUrls: ['./tagging.component.scss']
})
export class TaggingComponent {
  @Input() isReadOnly: boolean = false;
  @Input() isReady: boolean = false;
  permissionData$:Observable<any>
  loggedInUser!: UserInformation
  storeDropdowns?: StoreDropdowns;
  vendorDataTable: VendorTaggingTable[] = [];
  vendorDataSource: any = [];
  deactivatedVendorList: any = [];
  itemList: IItemToRequest[] = [];
  deactivatedItems: IItemToRequest[] = [];
  previousItemList: IItemToRequest[] = [];
  vendorTaggingList = [];
  isTaggingValue: boolean = false;
  sourcingCompleted : boolean = false;
  isEditable : boolean = true;
  documentStatusId: number = 0;
  taggingDataSource = new MatTableDataSource<VendorTaggingTable>(this.vendorDataTable);
  taggingColumns = [
    {
      columnDef: 'SourcingStatus',
      header: 'Sourcing status',
      cell: (element: VendorTaggingTable) => `${element.SourcingStatusName}`,
    },
    {
      columnDef: 'ItemNo',
      header: 'Item no.',
      cell: (element: VendorTaggingTable) => `${element.displayItemNumber}`,
    },
    {
      columnDef: 'ItemDescription',
      header: 'Item description',
      cell: (element: VendorTaggingTable) => `${element.ItemDescription}`,
    },
    {
      columnDef: 'VendorsTagged',
      header: 'Vendors tagged',
      cell: (element: VendorTaggingTable) => `${element.VendorsTagged}`,
    },
    {
      columnDef: 'MaterialSubGroup',
      header: 'Material sub group',
      cell: (element: VendorTaggingTable) => `${element.MaterialSubGroupName}`,
    }
  ];
  taggingDisplayedColumns = [
    ...this.taggingColumns.map((c) => c.columnDef),
  ];
  destroy$: Subject<boolean> = new Subject<boolean>();
  rowSelection = new SelectionModel<VendorTaggingTable>(true, []);
  pageSizeOptions = [5, 10, 20, 50];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private backendService: BackendApiService,
    private transformer: FormTransformerPipe,
    private permissionService:PermissionsService,
    private store: Store<{
      form: MyPurchaseForm;
      tagging: VendorTagging;
      dp: StoreDropdowns;
      user: UserInformation;
    }>
  ) {
    console.log("TAGGING COMPONENT constructor")
    this.permissionData$ = this.permissionService.getService().pipe(takeUntil(this.destroy$))
    // set current user
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
      this.loggedInUser = user;
    })
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.storeDropdowns = dp;
      });

    this.store
      .select('tagging')
      .pipe(takeUntil(this.destroy$))
      .subscribe((tagging: any) => {
        if (tagging.tags.length > 0) {
          this.isTaggingValue = true;
        }
      });
  }
  ngOnInit() {
    console.log("TAGGING COMPONENT ngOnInit")
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        if (this.storeDropdowns) this.checkIfRfs(form, this.storeDropdowns);
        if(form.documentStatusId != 15) this.isEditable = false;
        this.documentStatusId = form.documentStatusId;
        this.vendorDataSource = form.VendorsToSource;
        this.itemList = form.ItemList || [];
        if(this.deactivatedItems.length > 0){
          this.sourcingCompleted = true;
          this.itemList = this.itemList.concat(this.deactivatedItems);
        }
        if(this.deactivatedVendorList.length > 0){
          this.vendorDataSource = this.vendorDataSource.concat(this.deactivatedVendorList);
        }
        if(this.itemList.length > 0){
          this.convertToTaggingTable(this.itemList);
        }
        this.setEditingRights(this.itemList)
      });

    this.store
      .select('tagging')
      .pipe(takeUntil(this.destroy$))
      .subscribe((tagging: any) => {
        let vendorTaggingSet = new Set(); 
        this.vendorTaggingList = tagging.tags.filter((tag: any) => {
          if (this.allFieldsAreEmpty(tag)) return false
          const tagString = JSON.stringify(tag);
          if (vendorTaggingSet.has(tagString)) {
            return false;
          }
          vendorTaggingSet.add(tagString);
          return true;
        });
        if(this.itemList.length > 0){
          this.vendorDataTable = this.convertToTagging(this.vendorTaggingList);
          this.taggingDataSource = new MatTableDataSource<VendorTaggingTable>(this.vendorDataTable)
        }
      });
  }
  allFieldsAreEmpty(tag: VendorTagging) {
    return !tag.id && !tag.status && (!tag.vendorNumber || tag.vendorNumber.length == 0)
  }
  setEditingRights(itemList: IItemToRequest[]) {
    if (this.vendorDataTable.length == 0) return
    let peEditableItems: any[] = []
    for (const item of itemList) {
      if (item.AddItems.PurchaseExecutive == this.loggedInUser.userName) {
        peEditableItems.push(item.AddItems.itemId)
      }
    }
    let updatedVendorDataTable = this.vendorDataTable.map(x => {
      return {
        ...x,
        isEditable: peEditableItems.includes(x.itemId) ? true : false
      }
    })
    this.vendorDataTable = updatedVendorDataTable
    this.taggingDataSource.data = this.vendorDataTable
  }

  convertToTagging(tagList: any[]) {
    let tableTable: VendorTaggingTable[] = [];
    for (const item of tagList) {
      console.log("*** itemList.length ***",this.itemList.length)
      console.log("*** tagList.length ***",tagList.length)
      let editedItem = this.itemList.filter((items: any) => items.AddItems.PurchaseItemId == item.id);
      console.log("editedItem : ", editedItem);

      let tableObj: VendorTaggingTable = {
        SourcingStatusName: SourcingStatus.find((status) => {
          return status.SourcingStatusId == item.status
        })?.name ?? (item.status ? (editedItem[0]?.AddItems.TaggedVendors ?? 'Potential vendor identified') : ''),
        itemId: editedItem[0]?.AddItems.itemId,
        displayItemNumber: editedItem[0]?.AddItems.displayItemNumber,
        ItemDescription: editedItem[0]?.AddItems.ItemDescription,
        VendorsTagged: this.tagVendorsByNo(item.vendorNumber),
        MaterialSubGroupName: editedItem[0]?.AddItems.MaterialSubGroupId?.Name ?? '',
        isEditable: editedItem[0]?.AddItems.PurchaseExecutive == this.loggedInUser.userName ? true : false
      };
      tableTable.push(tableObj);
    }

    return tableTable;
  }

  convertToTaggingTable(itemList: IItemToRequest[]) {
    let storeVendorTagging = [];
    for (const item of itemList) {
      let tagObj = {
        id: item.AddItems.PurchaseItemId ?? 0,
        vendorNumber: this.taggedVendorsIds(item) ?? [],
        status: SourcingStatus.find((status) => {
            return status.SourcingStatusId == item.AddItems.SourcingStatusId
          })?.SourcingStatusId ?? (item?.AddItems.TaggedVendors ? 1 : null),
        }
      if(!item.Strikethrough && this.documentStatusId == 15){
        storeVendorTagging.push(tagObj);
      }else if(this.documentStatusId != 15){
        storeVendorTagging.push(tagObj);
      }
    }
    if (!this.isTaggingValue) {
      this.store.dispatch(
        addVendorTagging({
          tagging: storeVendorTagging
        })
      );
    }
  }

  taggedVendorsIds(item: IItemToRequest) {
    let vendorsArray = [];
    if (item.AddItems.TaggedVendors) {
      vendorsArray = item.AddItems.TaggedVendors.map(function (key: any) {
        return key.VendorNumber;
      });
    }
    console.log("vendorsArray : ", vendorsArray)
    return vendorsArray;
  }

  tagVendorsByNo(vendorNo: any) {
    let vendors;
    let vendorsArray: any = [];

    console.log("vendorNo : ", vendorNo);
    vendorNo.forEach((vendor: any) => {
      let selectedVendor = this.vendorDataSource.filter((v: any) => v.VendorNumber == vendor)[0]?.Name;
      vendorsArray.push(selectedVendor);
    })
    vendors = vendorsArray.join(', ');
    console.log("vendorsArray : ", vendorsArray);
    return vendors;
  }

  async checkIfRfs(form: MyPurchaseForm, storeDropdowns: StoreDropdowns) {
    if (doesNotMeetRfsCriteria(form)) return
    if (this.deactivatedItems.length > 0) return;
    console.log('returned')
    const resp: RfsSourcingResponse = await lastValueFrom(this.backendService.getSourcingOutcomes(form.documentNo!))
    if (resp.deactivatedItemList) {
      console.log('inside')
      let results = this.transformer.parseItemListData(resp.deactivatedItemList, storeDropdowns).map(x => ({
        ...x,
        isDeleted: true
      }))
      this.deactivatedItems = results
    }
    let newArr: Vendor[] = []
    if (resp.deactivatedVendorList) {
      for (let vendor of resp.deactivatedVendorList) {
        newArr.push({ ...vendor, isDeleted: true })
      }
      this.deactivatedVendorList = newArr;
    }
  }

  navigateToTagVendorItem(row: any) {
    if (row == 0) {
      this.router.navigate([this.router.url.split(';')[0], 'tag-item-vendor']);
    } else {
      this.router.navigate([this.router.url.split(';')[0], 'tag-item-vendor', row.itemId]);
    }
  }

  masterVToggle() {
    if (this.isAllVSelected()) {
      this.rowSelection.clear();
    } else {
      this.taggingDataSource.data.forEach((row) =>
        this.rowSelection.select(row)
      );
    }
  }

  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.rowSelection.selected.length;
    const numRows = this.taggingDataSource.data.length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.rowSelection.selected.length !== 0) return true;
    return false;
  }
  // checkbox toggling
  onCheckboxChange($event: any, row: any) {
    $event ? this.rowSelection.toggle(row) : null;
  }

  editVendorOpen(row: Vendor) {

  }
  openDialog(record: any) {
    console.log("record : ", record)
  }
}
